import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import Client from './client'

import 'normalize.css/normalize.css'
import './i18n'
import './styles/app.css'

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Client />
    </BrowserRouter>
  </React.StrictMode>
)
